export class ToBePaid {
  id: number;
  entry_group_id: number;
  bank_account_id: number;
  weekly_rate_id: number;
  allocation_type_id: number;
  bill_type_id: number;
  matter_id: number;
  check_number: number;
  amount: number;
  status: string = 'O';
  description: string;
  is_printed: boolean;
  type: string;
  created_at: any;
  updated_at: any;
  created_by: any;
  updated_by: any;
  chart_of_account_id: number;
  contact_id: number;
  address_id: number;
  category: string;
  paid_bill_id: number;
  deposit_id: number;
  for_entry_id: number;
  invoice_id: number;
  reverse_entry_id: number;
  rate_type_id: number;
  deduction_id: number;
  document_id: number;
  position: number;
  entriescol: string;
  payment_method_id: number;
  surcharge_amount: number;
  billing_id: number;
  bill_type_name: string;
  vendor_id: any;
  skipPayment: boolean = false;
  balance: number;
  is_charge: boolean;
  is_payment: boolean;
  is_priority: boolean;
  vendor_name: string;
  selected_for_payment: boolean = false;
  matter_name: string;
  vendor_account_number: string;
  hovering: boolean = false;
  ancestry: any;
  intranet_id: number;
  status_name: string;
  document_url: string;
  document_text: string;
  chart_of_account_name: string;
  created_at_date: any;

  valid(): boolean {
    if (this.vendor_id && this.bill_type_name && this.contact_id && this.chart_of_account_id && this.status && this.amount && this.matter_id) return true;
    else return false;
  }

  fromJSON(json: any) {
    let scope: any = this;
    for (var propName in json) scope[propName] = json[propName];
    return this;
  }
}
